import PersonIcon from '@mui/icons-material/Person';
import RoomIcon from '@mui/icons-material/Room';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ContentBox } from '@/components/shared/content-box';
import { PaymentMethod } from '@/data/catalog/offer/interfaces';
import { StyledBox } from '@/packages/courses/pages/checkout/components/styled-box';
import {
  paymentMethodIcon,
  paymentMethodLabel,
} from '@/packages/courses/pages/checkout/constants/payment-methods';
import { useCheckoutWizard } from '@/packages/courses/pages/checkout/hooks/useCheckoutWizard';
import { CheckoutStepIds } from '@/packages/courses/pages/checkout/types';
import { formatMoney } from '@/utils/format-money';
import { cepMask } from '@/utils/masks/cep';
import { cpfMask } from '@/utils/masks/cpf';
import { phoneMask } from '@/utils/masks/phone';

export const DataConfirmationStep = () => {
  const { values, actions, offer } = useCheckoutWizard();
  const customerInfo = values[CheckoutStepIds.CustomerInfo];
  const paymentMethod = values[CheckoutStepIds.PaymentMethod]?.paymentMethod;
  const cardNumber = values[CheckoutStepIds.CreditCardDetails]?.number;
  const installments =
    values[CheckoutStepIds.CreditCardInstallments]?.installments;

  const handleEditName = () => {
    actions.navigate(CheckoutStepIds.CustomerInfo);
  };

  const handleEditPaymentMethod = () => {
    actions.navigate(CheckoutStepIds.PaymentMethod);
  };

  const showCardNumber = paymentMethod === PaymentMethod.Card && cardNumber;

  return (
    <Box>
      <Typography variant="h1" color="primary.dark">
        Revise e confirme
      </Typography>
      <Stack spacing={2} mt={3}>
        <ContentBox
          direction={{ md: 'row' }}
          alignItems="flex-start"
          justifyContent="space-between"
          gap={2}
        >
          <Stack flex={1} spacing={4}>
            <Stack direction="row" alignItems="start" spacing={2}>
              <StyledBox>
                <PersonIcon />
              </StyledBox>
              <Stack>
                <Typography>{customerInfo?.name}</Typography>
                <Typography>CPF {cpfMask(customerInfo?.cpf ?? '')}</Typography>
                <Typography>
                  Contato {customerInfo?.countryCode}{' '}
                  {phoneMask(customerInfo?.phone)}
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={2}>
              <StyledBox>
                <RoomIcon />
              </StyledBox>
              <Stack>
                <Typography>
                  {customerInfo?.street}, {customerInfo?.number}{' '}
                </Typography>
                <Typography>{cepMask(customerInfo?.cep ?? '')}</Typography>
              </Stack>
            </Stack>
          </Stack>
          <Button onClick={handleEditName}>Alterar identificação</Button>
        </ContentBox>

        <ContentBox
          direction={{ md: 'row' }}
          alignItems="flex-start"
          justifyContent="space-between"
          gap={2}
        >
          <Stack direction="row" alignItems="center" spacing={2} flex={1}>
            <StyledBox>
              {paymentMethodIcon[paymentMethod as PaymentMethod]}
            </StyledBox>
            <Stack>
              <Typography>
                {paymentMethodLabel[paymentMethod as PaymentMethod]}
              </Typography>
              {showCardNumber && (
                <Typography>
                  {installments}x{' '}
                  {formatMoney(
                    offer?.checkout_pricing?.installments?.[installments! - 1]
                      ?.amount ?? 0
                  )}
                </Typography>
              )}
            </Stack>
          </Stack>
          <Button onClick={handleEditPaymentMethod}>Alterar pagamento</Button>
        </ContentBox>
      </Stack>
    </Box>
  );
};
